import { useForm } from "react-hook-form";

import { ReportSelectFiltersProps } from "./types";
import { useStoresAndShopkeepersStore } from "@repo/core/stores/storesAndShopkeepers";
import { useDeviceType } from "@repo/core/hooks/useDeviceType";
import { ProposalsResource } from "@repo/core/services/resources/proposals";
import { MobileProposalResource } from "@repo/core/services/resources/mobile-proposal";
import { apiInstance } from "@repo/core/services/instances/api";
import { useQuery } from "@tanstack/react-query";
import { useReportFiltersStore } from "@repo/core/stores/reports-filters";

const proposalsResource = new ProposalsResource(apiInstance);

const mobileProposalResource = new MobileProposalResource(apiInstance);

export const useReportSelectFilters = ({
  onClose
}: ReportSelectFiltersProps) => {
  const { availableStores } = useStoresAndShopkeepersStore();

  const {
    selectedAttendant,
    selectedProduct,
    selectedStore,
    selectedServicePoint,
    setSelectedAttendantFilter,
    setSelectedProductFilter,
    setSelectedStoreFilter,
    setSelectedServicePointFilter
  } = useReportFiltersStore();

  const { isMobile } = useDeviceType();

  const { control, handleSubmit, watch } = useForm<{
    store: string;
    product: string;
    attendant: string;
  }>({
    values: {
      store: selectedStore,
      product: selectedProduct,
      attendant: selectedAttendant
    }
  });

  const selectedProductFormValue = watch("product");

  //TODO: Remove these mocks and implement API
  const availableProducts = [
    {
      strProduto: "0073",
      strDescricao: "ALIBAIMPORT"
    },
    {
      strDescricao: "REDESUPERATACADO",
      strProduto: "0096"
    },
    {
      strDescricao: "REDESUPERATACADO",
      strProduto: "0116"
    }
  ];

  const { data: servicePoints, isFetching: isFetchingServicePoints } = useQuery(
    {
      queryKey: ["servicePoints", selectedProductFormValue],
      //TODO: Remove hardcoded params
      queryFn: () =>
        mobileProposalResource.fetchPointList(selectedProductFormValue),
      select: (data) => data.data,
      enabled: !!selectedProductFormValue,
      // eslint-disable-next-line @tanstack/query/no-deprecated-options
      onSuccess: (data) => {
        setSelectedServicePointFilter(data?.[0]?.ponto || "");
      }
    }
  );

  const { data: attendantsResponse, isFetching: isFetchingAttendants } =
    useQuery({
      queryKey: [
        "attendants",
        selectedServicePoint,
        selectedProductFormValue,
        selectedProduct
      ],
      queryFn: () =>
        proposalsResource.fetchAttendants({
          //TODO: Remove hardcoded params
          strProduto: selectedProduct || selectedProductFormValue,
          strBandeira: "01",
          strPontoAtendimento: selectedServicePoint
        }),
      select: (data) => data.data,
      enabled: !!selectedServicePoint
    });

  const onSubmitForm = handleSubmit(
    (data: { store: string; product: string; attendant: string }) => {
      setSelectedProductFilter(data.product);
      setSelectedAttendantFilter(data.attendant);
      setSelectedStoreFilter(data.store);
      onClose?.();
    }
  );

  const isFetchingFilters = isFetchingServicePoints || isFetchingAttendants;

  return {
    control,
    onSubmitForm,
    availableStores,
    availableProducts,
    availableAttendants: attendantsResponse,
    availableServicePoints: servicePoints,
    isFetchingFIlters: isFetchingFilters,
    isMobile,
    isFetchingFilters,
    selectedAttendant
  };
};
